import { refreshUser } from '@tshared/auth/token-manager'
import { config } from '@tshared/config/config'
import type { User } from '@tshared/models'
import { useUserStore } from '@tshared/stores/user-session.store'
import ky from 'ky'

let refreshRequest: Promise<User | null> | null = null

function applyAuthHeaders(request: Request) {
  const token = useUserStore.getState().user?.accessToken

  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`)
  } else {
    request.headers.delete('Authorization')
  }

  request.headers.set('x-ext-authz-sso-token-subdomain', config.getHeaderHost())
}

export const req = ky.create({
  timeout: 10000,
  hooks: {
    beforeRequest: [
      ({ request }) => {
        applyAuthHeaders(request)
      },
    ],

    afterResponse: [
      async ({ request, options, response }) => {
        // not 401, return response
        if (response.status !== 401) {
          return response
        }

        // avoid refresh token endpoint self-loop
        if (request.url.includes('refresh-token')) {
          return response
        }

        // multiple requests share a refresh promise
        refreshRequest ??= refreshUser(true)

        try {
          const user = await refreshRequest

          // refresh failed
          if (!user?.accessToken) {
            return response
          }
        } catch {
          return response
        } finally {
          refreshRequest = null
        }

        // clone original request
        const newRequest = request.clone()

        // write new token
        applyAuthHeaders(newRequest)

        // replay the request
        return ky(newRequest, options)
      },
    ],
  },
})

export default req
